import { formatCurrency, formatDateTime } from "@/common/utils/formatters";
import { DownloadIcon } from "lucide-react";
import { PaymentData } from "../types/payment.type";
import { Link } from "react-router-dom";
import { billPaymentStatus } from "../constants/billPaymentStatus.constant";
import { billPaymentType } from "../constants/billPaymentType.constant";
import PaymentChangeStatusModal from "../components/DocumentsTab/PaymentChangeStatusModal";

export class BillPaymentsTransformer {
  static tableTransformer() {
    return (payments: PaymentData[]) => {
      return payments.map((payment) => ({
        ...payment,
        status: payment?.status ? billPaymentStatus[payment?.status as keyof typeof billPaymentStatus] : '',
        type: payment.type ? (billPaymentType[payment.type as keyof typeof billPaymentType] || payment.type) : '',
        author: payment.uploaded_by ? payment.uploaded_by.full_name : '',
        issued_at: payment.data?.issued_at && formatDateTime(new Date(payment.data.issued_at)),
        paid_total: payment?.paid_total ? formatCurrency(Number(payment.paid_total)) : '',
        paid_at: payment?.paid_at ? formatDateTime(new Date(payment.paid_at)) : '',
        canceled_at: payment?.canceled_at ? formatDateTime(new Date(payment.canceled_at)) : '',
        title_number: payment.data?.title_number,
        actions: (
          <div className="flex items-center gap-4">
            <PaymentChangeStatusModal payment={payment} />

            {payment.pdf?.url ? (
              <Link to={payment.pdf?.url} target="_blank">
                <DownloadIcon strokeWidth={1} />
              </Link>
            ) : ''}
          </div>
        )
      }));
    };
  }
}
